import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button,   } from 'semantic-ui-react';

class FindShotChange_list extends Component {
  constructor(props) {
    super(props);

    this.state = {
      DialogHeight: 300,
      isShowIgnorelist: false,
    };
  }
  async componentDidMount() {
    let height = window.innerHeight - 600;
    await this.setState({ DialogHeight: height });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
    }
  }

  render() {
    const { tableColMapping } = this.props.transOperation;
    const { findShotChangeErrorData } = this.props.findOperation;

    let mainContent;

    let listView;
    let findAllTargetDataCount = 0;
    if (findShotChangeErrorData !== null) {
      listView = findShotChangeErrorData.map((obj, index) => {
        const { nextIndex, outTime, type, rowIndex, second } = obj;

        if (
          obj.isIgnoreShotchange === true
          // || obj.isInShotChangeActive === true ||
          // obj.isOutShotChangeActive === true
        ) {
          return '';
        }
        return (
          <li className='findAllObj'>
            <div>
              <a
                onClick={() => {
                  this.props.setFindAllSelectRowCol(
                    rowIndex,
                    tableColMapping[`${type}`]
                  );

                  //影片移動
                  this.props.playerSeek(second);
                }}
              >
                {obj.message}
              </a>
              <Button
                size='mini'
                style={{
                  padding: '3px',
                  background: '#9191d3',
                  color: 'white',
                }}
                onClick={() => {
                  this.props.changeRow(obj);
                }}
              >
                change
              </Button>
            </div>
          </li>
        );
      });

      findAllTargetDataCount = findShotChangeErrorData.length;
    }

    let ignorelistView;
    ignorelistView = findShotChangeErrorData.map((obj, index) => {
      const { nextIndex, outTime, type, rowIndex, second } = obj;

      if (obj.isIgnoreShotchange === false) {
        return '';
      }

      return (
        <li className='findAllObj'>
          <div>
            <a
              onClick={() => {
                this.props.setFindAllSelectRowCol(
                  rowIndex,
                  tableColMapping[`${type}`]
                );

                //影片移動
                this.props.playerSeek(second);
              }}
            >
              {obj.message}
            </a>
            {/* <Button
              size="mini"
              style={{
                padding: "3px",
                background: "#9191d3",
                color: "white",
              }}
              onClick={() => {
                this.props.changeRow(obj);
              }}
            >
              change
            </Button> */}
          </div>
        </li>
      );
    });

    mainContent = (
      <div
        className='small'
        style={{
          overflow: 'scroll',
          backgroundColor: '#eed3d7',
          height: `${this.state.DialogHeight}px`,
        }}
      >
        <b>
          <h2 style={{ color: '#b94a48', fontSize: '18pt' }}>
            Find Shot Change Error Total: {findAllTargetDataCount}
          </h2>
        </b>
        <div>
          <Button
            style={{
              fontSize: '10px',

              padding: '1px',
            }}
            onClick={async () => {
              this.setState({ isShowIgnorelist: !this.state.isShowIgnorelist });
            }}
          >
            Show Ignore
          </Button>
          <Button
            style={{
              fontSize: '10px',

              padding: '1px',
            }}
            onClick={async () => {
              this.props.ResetAll();
            }}
          >
            Reset
          </Button>

          <Button
            style={{
              fontSize: '10px',

              padding: '1px',
            }}
            onClick={async () => {
              this.props.changeAll(findShotChangeErrorData, false);
            }}
          >
            Change All
          </Button>

          <Button
            style={{
              fontSize: '10px',

              padding: '1px',
            }}
            onClick={async () => {
              this.props.changeAll(findShotChangeErrorData, true);
            }}
          >
            Change All (+fp check)
          </Button>

          <Button
            style={{
              fontSize: '10px',

              padding: '1px',
            }}
            onClick={async () => {
              this.props.removeSC(findShotChangeErrorData);
            }}
          >
            Remove SC
          </Button>
        </div>

        {this.state.isShowIgnorelist === true ? (
          <div style={{ backgroundColor: '#e7cfff' }}>
            <ul>{ignorelistView}</ul>
          </div>
        ) : null}

        <ul>{listView}</ul>
      </div>
    );

    return (
      <div
        className='findAllView'
        style={{ backgroundColor: '#eed3d7', color: '#3a87ad' }}
      >
        <div
          className='findAllView_close'
          onClick={() => {
            this.props.closefindAllView();
          }}
        >
          x
        </div>

        {mainContent}
      </div>
    );
  }
}

FindShotChange_list.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
});

export default connect(mapStateToProps, {})(withRouter(FindShotChange_list));



// WEBPACK FOOTER //
// ./src/components/translations/objects/FindShotChange_list.js